// src/pages/News/NewsCard.jsx
import React from "react";
import { FaEdit, FaTrashAlt, FaClock } from "react-icons/fa";

const NewsCard = ({ news, canModify, onEdit, onDelete, onOpenDetails }) => {
  const imageUrl = news.image_url || "/img/default_image.jpg";

  const createdLabel = news.created_at
    ? new Date(news.created_at).toLocaleDateString("fr-FR", {
        year: "numeric",
        month: "long",
        day: "numeric",
      })
    : "";

  const destinataires = news.destinataires_news || "Tout public";

  const stripHtml = (html = "") =>
    html.replace(/<[^>]+>/g, " ").replace(/\s+/g, " ").trim();

  const snippet = stripHtml(news.content || "").slice(0, 220) + (stripHtml(news.content || "").length > 220 ? "…" : "");

  return (
    <article
      className={`group relative flex flex-col overflow-hidden rounded-2xl border ${
        news.is_active
          ? "border-slate-200 bg-white/95 dark:border-slate-700 dark:bg-slate-800/95"
          : "border-amber-300 bg-amber-50/90 dark:border-amber-500/70 dark:bg-slate-800/95"
      } shadow-sm hover:shadow-xl transition-shadow duration-300`}
    >
      {/* Image + badges */}
      <div className="relative h-52 w-full overflow-hidden">
        <img
          src={imageUrl}
          alt={news.title}
          className="h-full w-full object-cover transform transition-transform duration-500 group-hover:scale-105"
        />

        {!news.is_active && (
          <span className="absolute top-3 left-3 rounded-full bg-amber-600/80 text-white text-[10px] font-semibold px-2 py-1 uppercase tracking-[0.16em] shadow">
            Archivée
          </span>
        )}

        {destinataires && (
          <span className="absolute bottom-3 left-3 rounded-full bg-black/60 backdrop-blur text-white text-[10px] font-semibold px-2 py-1 uppercase tracking-[0.14em]">
            {destinataires}
          </span>
        )}

        {canModify && (
          <div className="absolute top-3 right-3 flex gap-2">
            <button
              type="button"
              onClick={onEdit}
              className="inline-flex items-center justify-center w-8 h-8 rounded-full bg-white/90 text-slate-700 hover:bg-primary hover:text-white shadow-sm text-xs transition"
              title="Modifier l’actualité"
            >
              <FaEdit />
            </button>
            <button
              type="button"
              onClick={onDelete}
              className="inline-flex items-center justify-center w-8 h-8 rounded-full bg-white/90 text-red-600 hover:bg-red-600 hover:text-white shadow-sm text-xs transition"
              title="Supprimer l’actualité"
            >
              <FaTrashAlt />
            </button>
          </div>
        )}
      </div>

      {/* Contenu */}
      <div className="flex flex-col flex-1 p-4 gap-3">
        <header>
          <h3 className="text-lg md:text-xl font-bold text-slate-800 dark:text-slate-50 font-montserrat">
            {news.title}
          </h3>

          <div className="mt-1 flex flex-wrap items-center gap-2 text-[11px] text-slate-500 dark:text-slate-300">
            <span className="inline-flex items-center gap-1">
              <FaClock className="text-[10px]" />
              <span>{createdLabel}</span>
            </span>
            {news.author && (
              <span className="inline-flex items-center rounded-full bg-slate-100 dark:bg-slate-700 px-2 py-0.5 text-[10px] font-semibold text-slate-600 dark:text-slate-200">
                {news.author.prenom} {news.author.nom}
              </span>
            )}
          </div>
        </header>

        <div className="flex-1 text-sm text-slate-600 dark:text-slate-300">
          {snippet}
        </div>

        <div className="mt-2 flex justify-end">
          <button
            type="button"
            onClick={onOpenDetails}
            className="inline-flex items-center gap-2 rounded-full border border-primary bg-primary/90 px-4 py-2 text-xs font-semibold uppercase tracking-[0.16em] text-gray-800 hover:text-white shadow-sm hover:bg-primary transition"
          >
            Lire l’article complet
          </button>
        </div>
      </div>
    </article>
  );
};

export default NewsCard;
